import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_CALCULATOR  } from '../../redux/actions/types';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
  },
  margin: {
    height: theme.spacing(3),
  },
  tabText: {
    fontSize: '12px',
    [theme.breakpoints.down('md')]: {
      fontSize: '10px',
    },
  }
}));



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { calculator } = useSelector(state => state.data);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    let obj = newValue === 0 ? {
      rateTerm: 'Weekly',
      rate: 4
    } : newValue === 1 && {
      rateTerm: 'Semi-monthly',
      rate: 8.5
    };

    dispatch({type: SET_CALCULATOR, payload: obj})
  };



  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered dense>
          <Tab label={<><span id="discrete-slider-always" className={`${classes.tabText} text-center`}>
        Weekly
      </span>
      <Typography id="discrete-slider-always" className="text-center" color="primary" variant="caption">
        4%
      </Typography></>} {...a11yProps(0)} />
          <Tab label={<><span id="discrete-slider-always" className={`${classes.tabText} text-center`}>
        Semi-monthly
      </span>
      <Typography id="discrete-slider-always" className="text-center" color="primary" variant="caption">
        8.5%
      </Typography>
      </>} {...a11yProps(1)} />
          {/* <Tab label={<>
            <span id="discrete-slider-always" className={`${classes.tabText} text-center`}>
        Monthly
      </span>
      <Typography id="discrete-slider-always" className="text-center" color="primary" variant="caption">
        20%
      </Typography>
      </>} {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
    </Box>
  );
}
